import React from 'react';
import type { PageConfig } from '../../types/settings';
import { SuperSection } from '../structure';

/**
 * Layout do Fluxo A (`/renova_plano`).
 *
 * A página legada não tem cabeçalho nem rodapé do Recarga Fácil: ela usa a cor
 * e o logo da operadora dona da recarga, que vêm no próprio payload de
 * pagamento. Por isso ela tem um layout próprio, sem `BrandHeader`/`BrandFooter`.
 */
export function LayoutLegacy({ page }: { page: PageConfig }) {
  return (
    <div className="layout layout--legacy">
      <SuperSection sections={page.sections} />
    </div>
  );
}
